// extracted by mini-css-extract-plugin
export default {"main_container":"ErrorPage_main_container__4ykZA","image":"ErrorPage_image__9AaDl"};